export const myTest = {
    "my_test_type": "ປະເພດການທົດສອບ",
    "test_result": "ຜົນຂອງການທົດສອບ",
};

